var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57763 0V6C8.57763 6.53043 8.78835 7.03914 9.16342 7.41421C9.53849 7.78928 10.0472 8 10.5776 8H16.5776V18C16.5776 18.5304 16.3669 19.0391 15.9918 19.4142C15.6168 19.7893 15.1081 20 14.5776 20H2.57764C2.0472 20 1.5385 19.7893 1.16342 19.4142C0.78835 19.0391 0.577637 18.5304 0.577637 18V2C0.577637 1.46957 0.78835 0.960859 1.16342 0.585786C1.5385 0.210714 2.0472 0 2.57764 0H8.57763ZM10.0776 0.5V6C10.0776 6.13261 10.1303 6.25978 10.2241 6.35355C10.3178 6.44732 10.445 6.5 10.5776 6.5H16.0776L10.0776 0.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.c13825c525a392af9534b4d16e7d3177.svg";
export { ForwardRef as ReactComponent };